console.log('Property listing script loading...');

import React from 'react';
import { createRoot } from 'react-dom/client';
import PropertyListingContainer from './components/PropertyListingContainer';  // Updated import

console.log('Looking for root element...');
const root = document.getElementById('property-listings-root');
console.log('Root element found:', root);

if (root) {
    console.log('Attempting to create React root...');
    try {
        createRoot(root).render(
            <React.StrictMode>
                <PropertyListingContainer /> 
            </React.StrictMode>
        );
        console.log('React root created and rendered successfully');
    } catch (error) {
        console.error('Error creating React root:', error);
    }
} else {
    console.error('React root element not found!');
}